import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { pluck, Subscription } from 'rxjs';
import { ObjectListService, ObjectNode } from 'src/app/services/object-list.service';
import { MatCard, MatCardHeader, MatCardTitle, MatCardSubtitle, MatCardContent } from '@angular/material/card';
import { MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle } from '@angular/material/expansion';
import { GeaMesPiechartComponent } from './gea-mes-piechart/gea-mes-piechart.component';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatButton } from '@angular/material/button';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { MatDivider } from '@angular/material/divider';

@Component({
    selector: 'app-current-overview-status',
    templateUrl: './current-overview-status.component.html',
    styleUrl: './current-overview-status.component.scss',
    imports: [MatCard, MatCardHeader, MatCardTitle, MatCardSubtitle, MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle, GeaMesPiechartComponent, MatIcon, MatTooltip, MatCardContent, MatProgressSpinner, MatButton, MatMenuTrigger, MatMenu, MatMenuItem, MatDivider, RouterLink]
})
export class CurrentOverviewStatusComponent implements OnInit, OnDestroy {
  /*******************************************************
  * Service Injections                                   *
  ********************************************************/
  route = inject(ActivatedRoute);
  svcObjectList = inject(ObjectListService);

  /*******************************************************
  * Class Variables                                      *
  ********************************************************/
  protected dataSource: MatTableDataSource<any>;
  protected shiftDateOverview:any[];
  protected isLoading:boolean = true;

  protected selectedPlantName: string = '';
  protected selectedLine: string = '';
  protected selectedSubLine: string = '';

  protected objectList:ObjectNode[];
  protected lineMenuData:ObjectNode[];
  protected subLineMenuData:ObjectNode[];

  protected subOverview$:Subscription;

  constructor() {
    this.dataSource = new MatTableDataSource<any>();
  }

  ngOnInit(): void {
    this.getObjectList();
  }

  ngOnDestroy(): void {
    if (this.subOverview$) this.subOverview$.unsubscribe();    
  }

  getObjectList() {
    this.svcObjectList.objectList().pipe(pluck("Body")).subscribe((siteData) =>{
      if (siteData != null){
        console.debug("getObjectList siteData", siteData);
        this.objectList = siteData;
        
        // Check if the route has a site in it, if so look up the plant name to filter down to that
        let site:string = this.route.snapshot.paramMap.get("plant_name") ? this.route.snapshot.paramMap.get("plant_name") : '';

        if (site != '') {
          let currentPlant = this.objectList.find( ({ search }) => search === site )['Description'];
          this.selectedPlantName = currentPlant;
        }

        // Load the data
        this.getData();
        this.getMenuData();
       }
    }) 
  }

  getData(): void {
    if (this.subOverview$) this.subOverview$.unsubscribe();

    this.subOverview$ = this.svcObjectList.getShiftDateOverview(this.selectedPlantName, this.selectedLine, this.selectedSubLine).pipe(pluck("Body")).subscribe(
      (data) => {
        console.debug("getData", data);
        this.shiftDateOverview = data;
        this.isLoading = false;
      }
    );
  }

  getMenuData(){
    if (this.selectedPlantName != "") {
      this.lineMenuData = this.objectList.find( ({ Description }) => Description === this.selectedPlantName )['children'];
      this.lineMenuData = this.lineMenuData.filter(item => !item.ObjectID); // Filter out Objects
      console.debug("this.lineMenuData",this.lineMenuData);
    }

    if (this.selectedLine != "") {
      this.subLineMenuData = this.lineMenuData.find( ({ Description }) => Description === this.selectedLine )['children'];
      this.subLineMenuData = this.subLineMenuData.filter(item => !item.ObjectID); // Filter out Objects

      console.debug("this.subLineMenuData",this.subLineMenuData);
    }
  }

  navigate(plantName?:string, line?: string, subLine?: string) {
    this.selectedPlantName = plantName ? plantName : '';
    this.selectedLine = line ? line : '';
    this.selectedSubLine = subLine ? subLine : '';

    this.getData();
    this.getMenuData();
  }

  onClickName(value) {
    if (this.selectedPlantName == "") {
      this.navigate(value);
    } else if (this.selectedLine == "") {
      this.navigate(this.selectedPlantName, value);
    } else if (this.selectedSubLine == "") {
      this.navigate(this.selectedPlantName, this.selectedLine, value)
    }
  }

  changePlantName(plantName:string) {
    this.selectedLine = "";
    this.selectedSubLine = "";
    this.selectedPlantName = plantName;
    this.getData();
    this.getMenuData();
  }

  changeLine(line) {
    console.error("Changed Line", line);
    this.selectedLine = line;
    this.selectedSubLine = "";
    this.getData();
    this.getMenuData()
  }

  changeSubLine(subLine) {
    this.selectedSubLine = subLine;
    this.getData();
  }
}
